import React from 'react';

const CBBadge = ({
  count,
  dot = false,
  color = 'red', // Default color, can be Tailwind color class prefix e.g., 'bg-red-500'
  offset = [0, 0], // [horizontal, vertical] offset
  showZero = false,
  size = 'default', // 'default' or 'small'
  status, // 'success', 'processing', 'default', 'error', 'warning' - for status dots
  text, // Text for status badge
  title, // Tooltip text on hover
  children, // Content the badge is applied to
  className = '',
}) => {
  const isStatus = !!status;
  const isDot = dot || isStatus; // Status implies a dot

  const badgeClasses = [
    'absolute',
    'transform',
    'whitespace-nowrap',
    'text-black', // Assuming default text color is white
    'rounded-full',
    className,
  ];

  const sizeClasses = size === 'small' ? 'h-4 min-w-[1rem] px-1 text-xs' : 'h-5 min-w-[1.25rem] px-1.5 text-xs'; // Adjusted sizes
  const dotSizeClasses = size === 'small' ? 'h-1.5 w-1.5' : 'h-2 w-2';

  // Position based on offset - simplified, assumes top-right placement
  // More complex positioning might be needed depending on usage
  const positionStyle = {
    // top: `${offset[1]}px`,
    right: `${offset[0]}px`,
    // transform: 'translate(50%, -50%)', // Center on corner
  };

   // Determine background color class
   let bgColorClass = '';
   if (!isStatus) {
       // Standard count/dot badge color
       if (color.startsWith('bg-')) {
           bgColorClass = color; // Use Tailwind class directly
       } else {
           // Map common color names to Tailwind - extend as needed
           switch (color) {
               case 'red': bgColorClass = 'bg-red-500'; break;
               case 'blue': bgColorClass = 'bg-[#00f]'; break;
               case 'green': bgColorClass = 'bg-[#4ade80]'; break;
               case 'yellow': bgColorClass = 'bg-[#FFD02C]'; break;
               default: bgColorClass = 'bg-red-500'; // Default
           }
       }
   } else {
        // Status dot color
       switch (status) {
           case 'success': bgColorClass = 'bg-[#4ade80]'; break;
           case 'processing': bgColorClass = 'bg-[#00f]'; break; // Add pulse for processing
           case 'error': bgColorClass = 'bg-red-500'; break;
           case 'warning': bgColorClass = 'bg-[#FFD02C]'; break;
           case 'default':
           default: bgColorClass = 'bg-gray-400'; break;
       }
   }


  const showBadge = count > 0 || showZero || isDot || text;

  return (
    <span className="relative inline-block" title={title}>
      {children}
      {showBadge && !isStatus && !isDot && (
        <span
          className={`${badgeClasses.join(' ')} ${sizeClasses} ${bgColorClass} inline-flex items-center justify-center`}
          style={positionStyle}
        >
          {count}
        </span>
      )}
       {showBadge && isDot && !isStatus && (
         <span
           className={`${badgeClasses.join(' ')} ${dotSizeClasses} ${bgColorClass}`}
           style={positionStyle}
         ></span>
       )}
       {showBadge && isStatus && (
         <span className="flex items-center" style={positionStyle}>
             <span className={`inline-block ${dotSizeClasses} ${bgColorClass} rounded-full mr-1.5`}></span>
             {text && <span className="text-sm text-gray-700">{text}</span>}
         </span>
       )}
    </span>
  );
};

export { CBBadge };